<template>
  <div class="list" v-if="routeClass == 2">
    <div class="listTop">
      险种：
      <span
        :class="product_cate.length == 0 ? 'active' : ''"
        @click="cutType()"
      >
        不限
      </span>
      <span
        :class="product_cate.includes(item.id) ? 'active' : ''"
        @click="cutType(item.id)"
        v-for="(item, index) in proArray"
        :key="index"
      >
        {{ item.title }}
      </span>
    </div>
    <div class="cardBox">
      <div
        class="item"
        @click="skip(item.product_id)"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <div class="imgBox">
          <img
            :src="item.product_list_img[0].url"
            alt=""
            v-if="item.product_list_img"
          />
        </div>
        <div class="textBox">
          <p>{{ item.product_name }}</p>
          <span
            ><i class="iconfont icon-zhiye"></i> {{ item.product_work_cate }}
          </span>
          <span
            ><i class="iconfont icon-qiandai"></i> {{ item.insured_amount }}
          </span>
          <div>查看详情</div>
        </div>
      </div>
    </div>
  </div>
  <router-view v-else />
</template>
<script>
import { getProductCate } from "@/api/public";
import { getProductList } from "@/api/list";
export default {
  name: "list",
  data() {
    return {
      routeClass: "", //路由等级
      proArray: [], //产品分类列表
      product_cate: [], //产品分类选中
      tableData: []
    };
  },
  mounted() {
    // 获取当前路由等级
    this.routeClass = this.$route.matched.length;
    // 获取产品分类
    this.getProductCate();
    // 获取产品列表
    this.getProductList();
  },
  methods: {
    cutType(e) {
      if (e) {
        if (this.product_cate.includes(e)) {
          let index = this.product_cate.indexOf(e);
          this.product_cate.splice(index, 1);
        } else {
          this.product_cate.push(e);
        }
      } else {
        this.product_cate = [];
      }
      this.getProductList();
    },
    skip(e) {
      // 页面跳转
      this.$router.push({
        path: "/hr/list/detail",
        query: { id: e }
      });
    },
    // 获取产品分类
    getProductCate() {
      let that = this;
      getProductCate({ identi: 1 })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.proArray = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getProductList() {
      let that = this;
      let _data = {};
      if (that.product_cate) {
        _data.product_cate = that.product_cate;
      }
      getProductList(_data)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.tableData = res.data;
          } else {
            that.tableData = [];
            // that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  .listTop {
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 15px;
    flex-wrap: wrap;
    span {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      border-radius: 30px;
      border: 1px solid #fff;
      padding: 3px 20px;
      cursor: pointer;
      margin-left: 10px;
    }
    span.active {
      border-color: #2ca063;
      color: #2ca063;
    }
  }
  .cardBox {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-top: 30px;
    & > div.item {
      background: #fafbfb;
      border-radius: 20px 1px 20px 1px;
      border: 1px solid #e7e7e7;
      overflow: hidden;
      width: calc(20% - 16px);
      cursor: pointer;
      transition: all 0.25s;
      margin-right: 20px;
      margin-bottom: 20px;
      .imgBox {
        img {
          width: 100%;
        }
      }
      .textBox {
        background: #fafbfb;
        padding: 25px 25px 30px;
        p {
          font-size: 16px;
          font-weight: 600;
          color: #000000;
          margin: 0 0 15px;
        }
        span {
          background: #ffffff;
          border-radius: 3px;
          border: 1px solid #eb851c;
          display: inline-block;
          margin-right: 10px;
          font-size: 14px;
          font-weight: 400;
          color: #eb851c;
          padding: 2px 8px;
          margin-bottom: 10px;
          i {
            margin-right: 5px;
            vertical-align: middle;
          }
        }
        span + span {
          margin-right: 0;
        }
        div {
          margin-top: 15px;
          background: #ffffff;
          border: 1px solid #d2d2d2;
          border-radius: 5px;
          width: 95px;
          font-size: 14px;
          font-weight: 400;
          color: #616161;
          line-height: 20px;
          padding: 5px 17px;
          transition: all 0.25s;
        }
      }
    }
    & > div.item:hover {
      box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.1);
      .textBox div {
        background: #2ca063;
        color: #ffffff;
      }
    }
    & > div.item:nth-child(5n) {
      margin-right: 0;
    }
  }
}
@media screen and (max-width: 1760px) {
  .list {
    .cardBox {
      & > div.item {
        width: calc(25% - 15px);
      }
      & > div.item:nth-child(5n) {
        margin-right: 20px;
      }
      & > div.item:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .list {
    .cardBox {
      & > div.item {
        width: calc(33.33% - 13.34px);
      }
      & > div.item:nth-child(4n) {
        margin-right: 20px;
      }
      & > div.item:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
